import MainButton, {ButtonWithIcon} from "../forms/Buttons";
import React, {Component, useState} from "react";
import SelectButtons from "./SelectButtons";

import '../../../assets/sass/components/select/select-buttons-list.scss';
import ShadowScrollbars from "../custom_scrollbars/ShadowScrollbars";
import Icon, {ilsNoSearch} from "../Icon";

import classNames from 'classnames';
import Spinner from "react-bootstrap/Spinner";

class SelectButtonsList extends SelectButtons {
    render = () => {
        const {options, loading} = this.props;

        if (loading) {
            return this.renderLoading()
        } else if (options.length === 0) {
            return this.renderEmpty();
        } else {
            return (
                <div className="select-buttons-list">
                    {ShadowScrollbars.wrap(
                        <div className="select-buttons-list--items"> {options.map(this.renderOption)}</div>
                    )}
                </div>
            );
        }
    };

    renderOption = (option, index) => {
        const {value} = this.state;
        const {aspectRatio} = this.props;
        const active = option.value === value;
        const {svg, icon, label} = option;

        return (
            <SelectButtonsList.item key={index} active={active} text={label} icon={icon} svg={svg} aspectRatio={aspectRatio} onClick={(event) => this.handleSelect(event, option)}/>
        );
    };

    renderLoading = () => {
        return (
            <div className="select-buttons-list">
                <div className="h-100 d-flex justify-content-center align-items-center">
                    <Spinner animation="border" variant="primary"/>
                </div>
            </div>
        );
    };

    renderEmpty = () => {
        const text = "Sorry, No result found";
        const details = "We can’t find any item matching your search. Please try to search relevant agency or club names";

        return (
            <div className="select-buttons-empty-list">
                <Icon className="select-buttons-empty-list--icon" svg={ilsNoSearch}/>
                <span className="select-buttons-empty-list--text"> {text} </span>
                <span className="select-buttons-empty-list--details"> {details} </span>
            </div>
        )
    };
}

SelectButtonsList.item = props => {
    const {active, svg, icon, text, onClick} = props;

    return (
        <div className={classNames("select-buttons-list-item", active ? 'active' : '')} onClick={onClick}>
            <Icon className="select-buttons-list-item--icon" svg={svg} icon={icon}/>
            <span className="select-buttons-list-item--text"> {text} </span>
        </div>
    );
};

export default SelectButtonsList;
